import axios from "axios";

const BASE_URL_KKIAPAY = process.env.REACT_APP_BACKEND_API_URL + '/api/v1/admin/kkiapay';

export interface KkiapayVerificationReport {
  kkiapay_tx_id: string;
  kkiapay_status: string;
  kkiapay_amount: number;
  kkiapay_details?: object;
  kkiapay_error?: string;
  wallet_transactions: any[];
  charging_sessions: any[];
  is_registered: boolean;
}

export const verifyKkiapayTransaction = async (kkiapayTxId: string): Promise<KkiapayVerificationReport> => {
  const response = await axios.get<KkiapayVerificationReport>(`${BASE_URL_KKIAPAY}/verify/${kkiapayTxId}`);
  return response.data;
};

export const registerKkiapayTransaction = async (kkiapayTxId: string, walletId: string): Promise<any> => {
  const response = await axios.post(`${BASE_URL_KKIAPAY}/register/${kkiapayTxId}`, { wallet_id: walletId });
  return response.data;
};
